import PageContext from 'global_state/context/PageContext'
import content from 'languages/Lessons.json'
import { useContext, useState } from 'react'
import { lessonCreateReservation } from 'services/LessonsServices'
import { Lesson } from 'types/Lesson'
import SCSS from 'assets/scss/Lessons.module.scss'
import Loader from 'components/Loader'


interface LessonProps {
    lesson: Lesson
    // index: number,
    // showDayDate: boolean,
    language: any
}

function LessonElement(props: LessonProps) {
    const { page, dispatchPage } = useContext(PageContext)
    let lang = page.settings.language

    const renderDate = (date: Date | null) => {
        if (!date) {
            return null
        }

        let year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        let day = date.getUTCDate()
        let minutes = date.getUTCMinutes().toString();
        if (minutes == "0")
            minutes = "00";

        return (
            <span>{day}.{month}.{year} {date.getUTCHours()}:{minutes}</span>
        )
    }
    const renderTime = (date: Date | null) => {
        if (!date) {
            return null
        }

        let hours = ('0' + date.getUTCHours().toString()).slice(-2)
        let minutes = ('0' + date.getUTCMinutes().toString()).slice(-2)
        return (
            <span>{hours}:{minutes} </span>
        )
    }
    const renderLength = (date: Date | null) => {
        // console.log("render Length".toUpperCase(),date);

        if (!date) {
            return null
        }
        // console.log(date.getHours());
        // console.log(date.getMinutes());

        // console.log(date.getUTCHours());
        // console.log(date.getUTCMinutes());

        return (
            <span>{(date.getUTCHours() * 60) + date.getUTCMinutes()} minut</span>
        )
    }

    const renderDayDate = (date: Date) => {
        let year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        let day = date.getUTCDate()
        return (
            <h2>{day}.{month}.{year}</h2>
        )
    }
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [showSuccess, setShowSuccess] = useState<string | null>(null)

    const reservationClick = (lesson: Lesson) => {

        // for now - do not enroll as substitute if lesson do not have free spot
        // if (lesson.free_spots <= 0) {
        //     return
        // }

        setLoading(true);
        setError("");
        lessonCreateReservation(lesson.id, lang).then(data => {
            // console.log(data);

            if ('error' in data) {
                setError(data.error);
            }


            if ('lesson' in data && 'enroll_state' in data) {
                lesson.reservation_number = data.lesson.reservation_number
                lesson.free_spots = data.lesson.free_spots
                lesson.enrolled_spots = data.lesson.enrolled_spots
                setShowSuccess(data.enroll_state)
            }

            // if ('reservation_number' in data) {
            //     console.log(data);

            //     lesson.reservation_number = data.reservation_number;
            //     setShowSuccess(true)
            // }
            // if ('free_spots' in data) {
            //     // TODO: check also the enrolled spots
            //     // TODO: check if registered as the substitute
            //     lesson.free_spots = data.free_spots;
            // }

            setLoading(false);
        }).catch(error => {
            // console.log(error);
            setLoading(false);
        });
    }

    const renderFooter = (lesson: Lesson) => {

        if (lesson.reservation_number) {
            return (
                <div className={SCSS.footer}>
                    <button className={SCSS.reservedButton}>{content[lang].reservation} {lesson.reservation_number}</button>
                </div>
            )
        }


        if (lesson.free_spots <= 0) {
            return (
                <div className={SCSS.footer}>
                    <button className={SCSS.no_free_spots_button} onClick={() => reservationClick(lesson)}>{content[lang].enroll_as_substitute}</button>
                </div>
            )
            // return (
            //     <div className={SCSS.footer}>
            //         <button disabled={true} className={SCSS.no_free_spots_button}>{content[lang].no_free_spots}</button>
            //     </div>
            //
            // )
        }


        if (loading) {
            return (
                <div className={SCSS.footer}>
                    <button className={SCSS.loadingButton}><Loader /></button>
                </div>
            )
        }

        return (
            <div className={SCSS.footer}>
                <button onClick={() => reservationClick(lesson)}>{content[lang].enroll}</button>
            </div>
        )
    }
    const renderError = () => {
        if (error != "") {
            const er = (error in content[lang].error_message) ? content[lang].error_message[error] : error;
            return (
                <div className={SCSS.error}>
                    {er}
                </div>
            )
        }
    }

    const renderSuccess = () => {
        if (showSuccess == 'participant') {
            return (
                <div className={SCSS.success}>
                    {content[lang].success_message}
                </div>
            )
        }

        if (showSuccess == 'substitute') {
            return (
                <div className={SCSS.success}>
                    {content[props.language].success_message_substitute}
                </div>
            )
        }


    }
    const renderFreeSpots = () => {
        let free_spots = (props.lesson.free_spots <= 0) ? 0 : props.lesson.free_spots
        return (
            <>
                {free_spots} / {props.lesson.total_spots}
            </>
        )
    }
    const renderSubstitutes = () => {
        if (props.lesson.free_spots <= 0) {
            return (
                <div>
                    <strong>{content[lang].enrolled_substitutes}</strong> {props.lesson.enrolled_spots - props.lesson.total_spots}
                </div>
            )
        }
        return null
    }

    return (
        <div className={SCSS.lesson_wrapper}>
            {/* {props.showDayDate ? (renderDayDate(props.lesson.date)) : ""} */}
            <div className={SCSS.lesson}>
                <h3>{props.lesson.description}</h3>
                <div>
                    <strong>{content[lang].when}</strong>
                    {renderDate(props.lesson.date)} - {renderTime(props.lesson.getEndDate())}
                    ({renderLength(props.lesson.length)})
                </div>
                <div>
                    <strong>{content[lang].hall}</strong> {props.lesson.room_number}
                </div>
                <div>
                    <strong>{content[lang].lector}</strong> {props.lesson.coach}
                </div>
                <div>
                    <strong>{content[lang].reservation_fee}</strong> {props.lesson.price} Kč
                </div>
                <div>
                    <strong>{content[lang].free_spots}</strong> {renderFreeSpots()}
                </div>
                {renderSubstitutes()}
                {renderSuccess()}
                {renderError()}
                {renderFooter(props.lesson)}
            </div>
        </div>
    )
}

export default LessonElement
